module.exports = __webpack_public_path__ + "img/default-avatar.ff68b169.png";